import React from 'react';
import { Pressable, Image } from 'react-native';
import { Text } from '@tamagui/core';
import { YStack, XStack } from '@tamagui/stacks';
import { COLORS } from '@/constants/colors';
import { PAYMENT_METHODS } from '@/data/walletData';
import {
  getCardBackgroundColor,
  getCardBorderColor,
  CARD_BORDER_RADIUS,
  CARD_PADDING,
  BORDER_RADIUS_MEDIUM,
  FONT_SIZE_LG,
  FONT_SIZE_BASE,
  FONT_SIZE_XS,
  PAYMENT_ICON_SIZE,
  BORDER_WIDTH_MEDIUM,
  BORDER_WIDTH_THIN,
} from '../constants';

export type PaymentMethodSelectorProps = {
  isDark: boolean;
  textColor: string;
  subtextColor: string;
  selectedPaymentMethod: string | null;
  onSelectPaymentMethod: (methodId: string) => void;
};

const PaymentMethodSelector: React.FC<PaymentMethodSelectorProps> = React.memo(({
  isDark,
  textColor,
  subtextColor,
  selectedPaymentMethod,
  onSelectPaymentMethod,
}) => {
  return (
    <YStack
      backgroundColor={getCardBackgroundColor(isDark)}
      borderRadius={CARD_BORDER_RADIUS}
      padding={CARD_PADDING}
      borderWidth={BORDER_WIDTH_THIN}
      borderColor={getCardBorderColor(isDark)}
      space="$3"
    >
      <Text fontSize={FONT_SIZE_LG} fontWeight="700" color={textColor} marginBottom="$2">
        Wybierz sposób płatności
      </Text>

      <YStack space="$3">
        {PAYMENT_METHODS.map((method) => (
        <Pressable
          key={method.id}
          onPress={() => onSelectPaymentMethod(method.id)}
        >
          <XStack
            backgroundColor={
              selectedPaymentMethod === method.id
                ? isDark
                  ? 'rgba(255, 255, 255, 0.1)'
                  : 'rgba(0, 0, 0, 0.05)'
                : 'transparent'
            }
            padding="$3"
            borderRadius={BORDER_RADIUS_MEDIUM}
            alignItems="center"
            justifyContent="space-between"
            borderWidth={BORDER_WIDTH_MEDIUM}
            borderColor={
              selectedPaymentMethod === method.id
                ? COLORS.PRIMARY
                : getCardBorderColor(isDark)
            }
            gap="$3"
          >
            <Image
              source={method.icon}
              style={{ width: PAYMENT_ICON_SIZE, height: PAYMENT_ICON_SIZE }}
              resizeMode="contain"
            />
            <YStack flex={1}>
              <Text fontSize={FONT_SIZE_BASE} fontWeight="600" color={textColor}>
                {method.name}
              </Text>
              <Text fontSize={FONT_SIZE_XS} color={subtextColor} marginTop="$1">
                {method.description}
              </Text>
            </YStack>
            {/* Radio button */}
            <YStack
              width={24}
              height={24}
              borderRadius={12}
              borderWidth={BORDER_WIDTH_MEDIUM}
              borderColor={selectedPaymentMethod === method.id ? COLORS.PRIMARY : subtextColor}
              alignItems="center"
              justifyContent="center"
            >
              {selectedPaymentMethod === method.id && (
                <YStack
                  width={12}
                  height={12}
                  borderRadius={6}
                  backgroundColor={COLORS.PRIMARY}
                />
              )}
            </YStack>
          </XStack>
        </Pressable>
        ))}
      </YStack>
    </YStack>
  );
});

PaymentMethodSelector.displayName = 'PaymentMethodSelector';

export default PaymentMethodSelector;

